import * as React from "react";
import { SVGProps } from "react";

const SvgWithdrawal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 190 204"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#Withdrawal_svg__a)">
      <path
        d="M189.766 55.394a5.58 5.58 0 0 0-.337-1.087l-.383-.861a6.777 6.777 0 0 0-2.476-2.552 6.716 6.716 0 0 0-3.419-.937H7.719a6.715 6.715 0 0 0-3.419.937 6.775 6.775 0 0 0-2.476 2.552l-.383.86c-.15.35-.262.715-.337 1.088-.09.447-.136.903-.135 1.36v81.553c0 1.802.71 3.531 1.977 4.805a6.725 6.725 0 0 0 4.773 1.991h175.5c1.79 0 3.507-.716 4.773-1.991a6.818 6.818 0 0 0 1.977-4.805V56.753a6.858 6.858 0 0 0-.203-1.36Zm-8.797 80.647h-171V59.019h171v77.022Z"
        fill="#000"
      />
      <path
        d="m189.428 54.305-.383-.86L167.58 4.171a6.783 6.783 0 0 0-2.494-2.954 6.717 6.717 0 0 0-3.693-1.1H29.408a6.717 6.717 0 0 0-3.694 1.1 6.784 6.784 0 0 0-2.494 2.954L1.755 53.444l-.382.861c-.15.35-.263.714-.338 1.087h188.73a5.58 5.58 0 0 0-.337-1.087Zm-177.03-4.35L30.803 9.18h129.195l18.405 40.776H12.398ZM149.469 113.386h-108a4.487 4.487 0 0 1-3.182-1.327 4.547 4.547 0 0 1-1.318-3.204c0-1.202.474-2.354 1.318-3.204a4.487 4.487 0 0 1 3.182-1.327h108c1.193 0 2.338.478 3.182 1.327a4.547 4.547 0 0 1 1.318 3.204 4.547 4.547 0 0 1-1.318 3.204 4.488 4.488 0 0 1-3.182 1.327Z"
        fill="#000"
      />
      <path
        d="M149.469 149.632a54.525 54.525 0 0 0-5.533-23.992 54.132 54.132 0 0 0-15.505-19.05H62.506a54.318 54.318 0 0 0-16.622 21.533 54.704 54.704 0 0 0-4.146 26.951 54.6 54.6 0 0 0 9.373 25.587 54.107 54.107 0 0 0 20.535 17.786 53.695 53.695 0 0 0 26.529 5.508 53.743 53.743 0 0 0 25.848-8.154 54.211 54.211 0 0 0 18.663-19.766 54.66 54.66 0 0 0 6.783-26.403Z"
        fill="#00D37E"
      />
      <path
        d="M92.07 181.369v-7.431a28.548 28.548 0 0 1-6.75-1.744 21.023 21.023 0 0 1-6.39-3.896l5.467-8.631a25.064 25.064 0 0 0 5.423 3.194c1.515.624 3.133.955 4.77.974 1.404.13 2.81-.23 3.982-1.02a3.917 3.917 0 0 0 1.193-3.148 3.369 3.369 0 0 0-1.418-2.651 21.903 21.903 0 0 0-3.532-2.265l-4.5-2.266a24.939 24.939 0 0 1-4.5-2.945 14.963 14.963 0 0 1-3.533-4.009 10.342 10.342 0 0 1-1.417-5.573c-.21-3.376.839-6.709 2.94-9.348a13.478 13.478 0 0 1 8.422-4.924v-7.725h8.28v7.589a17.3 17.3 0 0 1 6.233 2.265 22.563 22.563 0 0 1 4.905 4.01l-6.278 7.295a16.514 16.514 0 0 0-3.802-2.674 8.697 8.697 0 0 0-3.87-.906 6.22 6.22 0 0 0-3.533.816 3.51 3.51 0 0 0-1.192 3.058 2.964 2.964 0 0 0 1.418 2.447c1.105.81 2.288 1.509 3.532 2.084l4.5 2.265a24.36 24.36 0 0 1 4.5 2.9 14.584 14.584 0 0 1 3.532 4.078 10.977 10.977 0 0 1 1.418 5.731 15.475 15.475 0 0 1-2.903 9.175 14.25 14.25 0 0 1-8.662 5.346v7.884l-8.235.045Z"
        fill="#051513"
      />
    </g>
    <defs>
      <clipPath id="Withdrawal_svg__a">
        <path
          fill="#fff"
          transform="translate(.9 .117)"
          d="M0 0h189v203.884H0z"
        />
      </clipPath>
    </defs>
  </svg>
);

export default SvgWithdrawal;
